import React from "react";
import VoucherList from "./VoucherList";
import { FiCheckCircle } from "react-icons/fi";

const ActiveVouchers = () => {
  return (
    <VoucherList
      title="Running Vouchers"
      filterStatus="active" // Normalized status for running vouchers
      icon={<FiCheckCircle color="#2e7d32" size={22} />}
    />
  );
};

export default ActiveVouchers;
